import script from "./BarcodeTypesMixin.vue?vue&type=script&lang=ts"
export * from "./BarcodeTypesMixin.vue?vue&type=script&lang=ts"

export default script